import { cva } from 'class-variance-authority';

export const alertActionOutlinedClass = {
  attention: 'border-x-2 border-y border-x-[hsl(var(--warning))] border-y-[hsl(var(--warning)/0.5)]',
  important: 'border-x-2 border-y border-x-[hsl(var(--destructive))] border-y-[hsl(var(--destructive)/0.5)]',
  neutral: ''
} as const;

export const alertActionVariants = cva(
  [
    'group flex w-full items-center justify-between gap-3 px-[17px] py-[9px]',
    'text-left font-sans',
    'rounded-2xl border border-border-strong bg-surface',
    'transition-[border-color,border-width,padding,background-color]',
    'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background'
  ].join(' '),
  {
    defaultVariants: { variant: 'neutral' },
    variants: {
      variant: {
        attention:
          'active:px-[16px] hover:border-[hsl(var(--warning)/0.7)] active:border-x-2 active:border-y active:border-x-[hsl(var(--warning))] active:border-y-[hsl(var(--warning)/0.5)]',
        important:
          'active:px-[16px] hover:border-[hsl(var(--destructive)/0.7)] active:border-x-2 active:border-y active:border-x-[hsl(var(--destructive))] active:border-y-[hsl(var(--destructive)/0.5)]',
        neutral: 'hover:bg-foreground/[0.04]'
      }
    }
  }
);

export const alertOutlinedBorderClass = {
  attention: 'border-x-2 border-y border-x-[hsl(var(--warning))] border-y-[hsl(var(--warning)/0.5)]',
  default: '',
  destructive: 'border-x-2 border-y border-x-[hsl(var(--destructive))] border-y-[hsl(var(--destructive)/0.5)]',
  important: 'border-x-2 border-y border-x-[hsl(var(--destructive))] border-y-[hsl(var(--destructive)/0.5)]',
  info: 'border-x-2 border-y border-x-[hsl(var(--info))] border-y-[hsl(var(--info)/0.5)]'
} as const;

export const alertVariants = cva(
  'relative w-full p-4 font-sans text-foreground rounded-2xl border border-border-strong bg-surface [&>svg]:absolute [&>svg]:left-4 [&>svg]:top-4 [&>svg]:size-5 [&>svg~*]:pl-7 [&>svg+div]:translate-y-[-1px]',
  {
    defaultVariants: { variant: 'default' },
    variants: {
      variant: {
        attention: '[&>svg]:text-[hsl(var(--warning))]',
        default: '',
        destructive: 'text-[hsl(var(--error-text))] [&>svg]:text-[hsl(var(--destructive))]',
        important: '[&>svg]:text-[hsl(var(--destructive))]',
        info: '[&>svg]:text-[hsl(var(--info))]'
      }
    }
  }
);